import { EntityTypes } from "./enums";

export interface SourcingRequestFeedback {
    feedbackId: string;
    requestId: string;
    userId: string;
    comment?: string;
    rating: number;
    created: number;
    entityType: EntityTypes.sourcingRequestFeedback;
}

export interface CreateSourcingRequestFeedbackInput {
    requestId: string;
    userId: string;
    comment?: string;
    rating: number;
}

export interface SourcingRequestFeedbackApiInput {
    rating: number,
    comment?: string
}

//JSON Schema for SourcingRequestFeedbackApiInput
export const SourcingRequestFeedbackApiInputSchema = {
    type: 'object',
    properties: {
        rating: { type: 'number', minimum: 1, maximum: 5 },
        comment: { type: 'string', minLength: 10, maxLength: 500 }
    },
    required: ['rating']
};